﻿import { date } from 'quasar'

class Formatters {
    CustomDate(d, format) {
        if (!d) return '';

        return date.formatDate(d, format);
    }

    CreateDate(d, offsetDays) {
        let newDate = d || new Date();
        if (offsetDays) {
            newDate = date.addToDate(newDate, { days: offsetDays });
        }
        return newDate;
    }

    async CreateDateRange(type) {
        return 
    }

    ISO(d) {
        return this.CustomDate(d, 'YYYY-MM-DDTHH:mm');
    }

    GetDayOfWeek(d, dayOfWeek) {
        var curDay = this.CustomDate(d, 'd');
        var offset = dayOfWeek - curDay;
        var dt = this.CreateDate(d, offset);
        return dt;
    }

    IsMidnight(d) {
        return this.CustomDate(d, 'H') == '0' &&
               this.CustomDate(d, 'm') == '0';
    }

    Date(d) {
        return this.CustomDate(d, 'MM/DD/YYYY');
    }

    Time(d) {
        return this.CustomDate(d, 'h:mm A');
    }

    DayOfWeek(d) {
        return this.CustomDate(d, 'dddd');
    }

    DateTime(d) {
        return this.CustomDate(d, 'MM/DD/YYYY hh:mm a');
    }

    Currency(val) {
        const f = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });
        return f.format(val);
    }

    Decimal(d) {
        return d;
    }

    SplitCamel(n) {
        return n.replace(/([a-z])([A-Z])/g, '$1 $2');
    }

    SplitParagraph(n) {
        if (!n) return '';
        const lines = n.split(/\r?\n/);
        const paragraphs = lines.map(l => `<p>${l}</p>`).join('');
        return paragraphs;
    }

    Initials(name) {
        if (!name) return 'NA';
        let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');

        let initials = [...name.matchAll(rgx)] || [];

        initials = (
            (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
        ).toUpperCase();

        return initials;
    }
}

export default new Formatters();